export const DYNAMIC_FRAGMENT_LITERALS = {
  STATEMENT: locale =>
    `
    sys { id }
    title
    description
    backgroundColor
    introColor
    statementColor
    statement
    curatedListCollection(limit: 2) {
      items {
        sys { id }
        title
        pagesCollection(limit: 3) {
          items {
            ... on PageDetail${locale} {
              ...pageDetail
            }
            ... on PageLanding${locale} {
              ...pageLanding
            }
            ... on PageDetailGlobal {
              ...pageDetailGlobal
            }
          }
        }
      }
    }
    keyPoints {
      title
      description
      bodyText
      ctasCollection(limit: 2) {
        items {
          ...cta
        }
      }
    }
  `,
  CURATED_LIST: locale =>
    `
    sys { id }
    title
    pagesCollection(limit: 3) {
      items {
        ... on PageDetail${locale} {
          ...pageDetail
        }
        ... on PageLanding${locale} {
          ...pageLanding
        }
        ... on PageDetailGlobal {
          ...pageDetailGlobal
        }
        ... on PageDynamicLanding {
          ...pageDynamicLanding
        }
      }
    }`,
  CURATED_LIST_GROUP: locale =>
    `
    sys { id }
    displayOnMobile
    listsCollection(limit: 6) {
      items {
        sys { id }
        title
        pagesCollection(limit: 3) {
          items {
            ... on PageDetail${locale} {
              ...pageDetail
            }
            ... on PageLanding${locale} {
              ...pageLanding
            }
            ... on PageDetailGlobal {
              ...pageDetailGlobal
            }
            ... on PageDynamicLanding {
              ...pageDynamicLanding
            }
          }
        }
      }
    }`,
  DYNAMIC_LANDING_RECIRCULATION_MODULE: locale => `
    ... on PageDynamicLanding${locale} {
      modulesCollection {
        items {
          ... on ModuleDynamicSection {
            title
            titleDetailText
            timeRange
          }
        }
      }
      pagesCollection {
        items {
          ... on PageDetail${locale} {
            ...pageDetail
            timeRange
          }
          ... on PageDetailGlobal {
            ...pageDetailGlobal
            timeRange
          }
        }
      }
    }
  `,
};
